import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

interface FeatureAccessStoreState {
  unknown: boolean
  patron: boolean
  checkin: boolean
  tiers: boolean
  specialsAndEvents: boolean
  rewardsJJ: boolean
  rewardsLocation: boolean
  sweepstakesJJ: boolean
  sweepstakesLocation: boolean
  communicationsPushNotifications: boolean
  communicationsBannerMessages: boolean
  noCommunications: boolean
  setFeatureAccess: (
    unknown: boolean,
    patron: boolean,
    checkin: boolean,
    tiers: boolean,
    specialsAndEvents: boolean,
    rewardsJJ: boolean,
    rewardsLocation: boolean,
    sweepstakesJJ: boolean,
    sweepstakesLocation: boolean,
    communicationsPushNotifications: boolean,
    communicationsBannerMessages: boolean,
    noCommunications: boolean
  ) => void
}

export const featureAccessStore = create<FeatureAccessStoreState>()(
  persist(
    (set) => ({
      unknown: false,
      patron: false,
      checkin: false,
      tiers: false,
      specialsAndEvents: false,
      rewardsJJ: false,
      rewardsLocation: false,
      sweepstakesJJ: false,
      sweepstakesLocation: false,
      communicationsPushNotifications: false,
      communicationsBannerMessages: false,
      noCommunications: false,
      setFeatureAccess: (
        unknown: boolean,
        patron: boolean,
        checkin: boolean,
        tiers: boolean,
        specialsAndEvents: boolean,
        rewardsJJ: boolean,
        rewardsLocation: boolean,
        sweepstakesJJ: boolean,
        sweepstakesLocation: boolean,
        communicationsPushNotifications: boolean,
        communicationsBannerMessages: boolean,
        noCommunications: boolean
      ) =>
        set({
          unknown,
          patron,
          checkin,
          tiers,
          specialsAndEvents,
          rewardsJJ,
          rewardsLocation,
          sweepstakesJJ,
          sweepstakesLocation,
          communicationsPushNotifications,
          communicationsBannerMessages,
          noCommunications,
        }),
    }),
    {
      name: 'feature-access-storage',
      storage: createJSONStorage(() => sessionStorage),
    }
  )
)
